export default __webpack_public_path__ + "static/developer_mobile@2x-ac115c1fdf2de417c5876112db8aa0a6.png";